// The video editor's layers strings (components/Editor), under t('editor.rve.layers.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  common: {
    volume: "Volume",
    mute: "Silenciar",
    unmute: "Ativar som",
  },
  tabs: {
    settings: "Configurações",
    style: "Estilo",
    allCount: "Tudo ({n})",
  },
  style: {
    appearance: "Aparência",
    fit: "Ajuste",
    fitCover: "Cobrir",
    fitContain: "Conter",
    fitFill: "Preencher",
    borderRadius: "Arredondamento",
    brightness: "Brilho",
    padding: "Espaçamento",
    paddingBackground: "Fundo do espaçamento",
    clear: "Limpar",
  },
  filter: {
    preset: "Filtro predefinido",
    custom: "Personalizado",
    presetPreview: "Prévia de {name}",
  },
  filterPresets: {
    none: "Nenhum",
    retro: "Retrô",
    vintage: "Vintage",
    wesAnderson: "Wes Anderson",
    noir: "Filme noir",
    polaroid: "Polaroid",
    cinematic: "Cinematográfico",
    cool: "Frio",
    warm: "Quente",
    expired: "Filme vencido",
    kodak: "Kodak",
    super8: "Super 8",
  },
  animation: {
    title: "Animações",
    enter: "Animação de entrada",
    exit: "Animação de saída",
  },
  animations: {
    none: "Nenhuma",
    fade: "Esmaecer",
    slideRight: "Deslizar",
    scale: "Escalar",
    bounce: "Quicar",
    flipX: "Virar",
    zoomBlur: "Zoom",
    slideUp: "Deslizar",
    snapRotate: "Giro rápido",
    glitch: "Glitch",
    swipeReveal: "Varrer",
    floatIn: "Flutuar",
  },
  image: {
    preview: "Prévia da imagem",
  },
  video: {
    preview: "Prévia do vídeo",
    playbackSpeed: "Velocidade de reprodução",
    reset: "Redefinir",
    selectSpeed: "Escolha a velocidade",
    speedNormal: "1x (normal)",
    speedCustom: "{speed}x (personalizada)",
  },
  pexels: {
    searchImages: "Buscar imagens...",
    searchVideos: "Buscar vídeos...",
    orientation: "Orientação",
    allOrientations: "Todas as orientações",
    landscape: "Horizontal",
    portrait: "Vertical",
    square: "Quadrado",
    size: "Tamanho",
    allSizes: "Todos os tamanhos",
    small: "Pequeno",
    medium: "Médio",
    large: "Grande",
    imagesFound: "{n} imagens encontradas",
    videosFound: "{n} vídeos encontrados",
    page: "Página {n}",
    photoBy: "Foto de {name}",
    videoBy: "Vídeo de {name}",
    unknown: "Desconhecido",
    by: "por {name}",
    noImagesFor: "Nenhuma imagem encontrada para \"{query}\"",
    noVideosFor: "Nenhum vídeo encontrado para \"{query}\"",
    poweredBy: "Com tecnologia de",
    fetchErrorTitle: "Erro ao carregar a mídia",
    fetchErrorBody: "Não foi possível carregar a mídia do Pexels. Tente de novo mais tarde.",
  },
  emptyState: {
    noneAvailable: "Não há {items} disponíveis",
    noResults: "Não encontramos {items}",
    noResultsIn: "Não encontramos {items} em {source}",
    tryAnother: "Tente outra busca",
    useSearch: "Use a busca para encontrar {items}",
    enterTerm: "Digite o que procura acima",
    mediaTypes: {
      templates: "modelos",
      videos: "vídeos",
      images: "imagens",
    },
  },
  localMedia: {
    savedUploads: "Arquivos enviados",
    upload: "Enviar",
    uploadMedia: "Enviar arquivos",
    uploadFailed: "Não foi possível enviar o arquivo. Tente de novo.",
    unsupportedType: "Tipo de arquivo não suportado",
    deleteMedia: "Excluir arquivo",
    all: "Tudo",
    images: "Imagens",
    videos: "Vídeos",
    audio: "Áudio",
    loading: "Carregando arquivos...",
    emptyTitle: "Nenhum arquivo",
    emptyHint: "Envie seu primeiro arquivo para começar",
    addToTimeline: "Adicionar à linha do tempo",
    fileTypes: {
      image: "imagem",
      video: "vídeo",
      audio: "áudio",
    },
  },
  sounds: {
    library: "Música do Clip-Short",
    moods: {
      suspense: "Suspense",
      epic: "Épica",
      uplifting: "Motivadora",
      calm: "Calma",
      playful: "Divertida",
      emotional: "Emocionante",
      tech: "Tecnologia",
      lofi: "Lo-fi",
      oriental: "Oriental",
      dramatic: "Dramática",
    },
    searchTab: "Efeitos sonoros",
    featuredTab: "Música",
    searchPlaceholder: "Buscar efeitos sonoros…",
    searching: "Buscando sons...",
    noResults: "Nenhum som encontrado",
    searchPrompt: "Busque um efeito sonoro",
    poweredBy: "Com tecnologia do Freesound.org",
    results: "{n} resultados",
    addToTimeline: "Adicionar à linha do tempo",
    loading: "Carregando...",
    loadMore: "Carregar mais",
    soundsFrom: "Sons do",
    creativeCommons: "(Creative Commons)",
    musicHint: "Nossa própria música, sem problema para postar em qualquer rede. Escolha um estilo, ouça as faixas e coloque uma sob o vídeo inteiro: ela toca baixinho sob a voz. Mude o volume na linha do tempo.",
    putUnder: "Colocar no vídeo",
    useInstead: "Usar esta",
    underVideo: "Neste vídeo: {mood}",
    removeMusic: "Tirar",
    listen: "Ouvir {mood}",
  },
  progressBar: {
    description: "Vai enchendo enquanto o vídeo toca, para quem assiste ver quanto falta. Ocupa o tempo da camada na linha do tempo.",
    colour: "Cor",
    colourSwatch: "Cor {color}",
    position: "Posição",
    top: "em cima",
    bottom: "embaixo",
    thickness: "Espessura",
    stretch: "Estender pelo vídeo inteiro",
    add: "Barra de progresso",
    replace: "Substituir a barra de progresso",
    addHint: "Mostra quanto falta do vídeo",
  },
};
